import {action, observable} from 'mobx';
import _ from 'lodash';

class SelectionState {
  onSelectionChange;
  nestedRowsAttr;
  onExpand;
  filter;

  @observable selectedIds = [];

  constructor({onSelectionChange, nestedRowsAttr, onExpand} = {}) {
    this.onSelectionChange = onSelectionChange;
    this.nestedRowsAttr = nestedRowsAttr;
    this.onExpand = onExpand;
  }

  @action setFilter(filter) {
    this.filter = filter;
  }

  isChecked(viewModel) {
    return viewModel.isFolder
      ? this.isFolderChecked(viewModel.data)
      : this.isModelSelected(viewModel.data);
  }

  async toggle(viewModel) {
    if (viewModel.isFolder) {
      await this.toggleFolder(viewModel.data);
    } else {
      this.toggleModel(viewModel.data);
    }
  }

  isModelSelected(model) {
    return _.includes(this.selectedIds, model.id);
  }

  collectDescendantIds(folder) {
    const descendantsIds = [...(_.map(folder[this.nestedRowsAttr], 'id') || [])];

    (folder.subfolders || []).forEach(subFolder => {
      descendantsIds.push(...this.collectDescendantIds(subFolder));
    });

    return descendantsIds;
  }

  hasLoadedChildren(folder) {
    const docs = folder[this.nestedRowsAttr] || [];
    const subfolders = folder.subfolders || [];
    return !_.isEmpty(docs) || !_.isEmpty(subfolders);
  }

  isFolderChecked(folder) {
    const descendantIds = this.collectDescendantIds(folder);
    if (_.isEmpty(descendantIds)) return false;

    return descendantIds.every(descendantId => _.includes(this.selectedIds, descendantId));
  }

  @action toggleModel(model) {
    if (_.includes(this.selectedIds, model.id)) {
     this.selectedIds.remove(model.id)
    } else {
      this.selectedIds.push(model.id)
    }

    this.onSelectionChange(this.selectedIds);
  }

  @action async toggleFolder(folder) {
    if (!this.hasLoadedChildren(folder)) {
      await this.onExpand(folder, this.filter);
    }

    const checked = this.isFolderChecked(folder);
    const descendantIds = _.map(folder[this.nestedRowsAttr], 'id');

    if (checked) {
      this.selectedIds = this.selectedIds.filter(id => !_.includes(descendantIds, id));
    } else {
      this.selectedIds = _.uniq([...this.selectedIds, ...descendantIds])
    }

    await Promise.all(
      folder.subfolders.map(subfolder => {
        if (this.isFolderChecked(subfolder) === checked) {
          return this.toggleFolder(subfolder)
        }
      })
    );

    this.onSelectionChange(this.selectedIds);
  }
}

export default SelectionState;
